import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ForgotPasswordModel } from '../../../model/forgot-password-model';
import { SharedModule } from '../../../shared/shared-module.ts.module';
import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, SharedModule],
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  form = new FormControl('', [Validators.required, Validators.email, Validators.maxLength(254)]);
  clientId: string | null = null;


  constructor(private serviceAuth: AuthService, private spinner: NgxSpinnerService, private route: ActivatedRoute) {
    this.clientId = this.serviceAuth.getClienteIdLocal();

    this.route.queryParams.subscribe(params => {
      this.clientId = params['client_id'];

      if (this.clientId)
        this.serviceAuth.setClienteIdLocal(this.clientId);
    })
  }

  submit() {
    if (this.form.invalid) {
      alert('Preencha o campo de email');
      this.form.markAllAsTouched()
      return;
    }

    const email = this.form.value;
    if (email === null) {
      alert('Email não pode ser nulo');
      return;
    }

    const clientId = this.serviceAuth.verificaClientId(this.clientId ?? '');
    if (clientId === null) {
      alert('Cliente invalido. Inicie a recuperacao pelo sistema que deseja acessar.');
      return;
    }
    const resetPasswordModel: ForgotPasswordModel = {
      email: email.trim().toLowerCase(),
      clientId,
    };
    this.spinner.show();

    this.serviceAuth.forgotPassword(resetPasswordModel).subscribe({
      next: () => {
        alert('Email enviado com sucesso');
        this.spinner.hide();

      },
      error: () => {
        alert('Erro ao enviar email');
        this.spinner.hide();

      }
    })
  }
}
